import {Range} from '~/common/FabricInvitation/components/Range/Range';
import {useImageSize} from '~/common/FabricInvitation/EventCreateDesign/components/PhotoEditor/common/useImageSize';
import {useImageSizeLimits} from '~/common/FabricInvitation/EventCreateDesign/components/PhotoEditor/common/useImageSizeLimits';
import {
  MAX_IMAGE_SIZE,
  MIN_IMAGE_SIZE,
  STEP_IMAGE_SIZE,
} from '~/common/FabricInvitation/EventCreateDesign/components/PhotoEditor/constants/imageSizeLimits';
import './SizeControl.sass';

export const SizeControl = ({canvas}) => {
  const {scaleValue, setImageScale} = useImageSize();

  useImageSizeLimits(canvas, {min: MIN_IMAGE_SIZE, max: MAX_IMAGE_SIZE});

  return (
    <div className="size-control">
      <div className="size-control__slider">
        <Range
          min={MIN_IMAGE_SIZE}
          max={MAX_IMAGE_SIZE}
          step={STEP_IMAGE_SIZE}
          value={scaleValue}
          onChange={setImageScale}
          onLocalChange={setImageScale}
          hasControls
          hiddenInput
          dataQaId="size-slider"
        />
      </div>
    </div>
  );
};
